export default {
  heading: {
    id: 'manageToken.heading',
    defaultMessage: 'API management',
  },

  accessToken: {
    id: 'manageToken.accessToken',
    defaultMessage: 'Access token',
  },

  searchApiEnabled: {
    id: 'manageToken.searchApiEnabled',
    defaultMessage: 'Search API (<code>POST /api/v6/profiles/search/</code>) is enabled for your company.',
  },

  searchApiDisabled: {
    id: 'manageToken.searchApiDisabled',
    defaultMessage: `Search API (<code>POST /api/v6/profiles/search/</code>) is not enabled for your company —
      requests get <code>402</code>. Contact your AmazingHiring manager to enable it.`,
  },

  searchApiDocs: {
    id: 'manageToken.searchApiDocs',
    defaultMessage: 'See the <link>Search API documentation</link>.',
  },

  description: {
    id: 'manageToken.description',
    defaultMessage: `
      <p>Amazing Hiring API is available only by <b>the access token</b>.</p>
      <p>This is <b>a single token for the whole company</b> — every integration of yours uses it.</p>
      <p>Please keep your token <b>secret</b>, because it's <b>permanent</b> and if someone will
      use your access key it may lead to significant money loss</p>
      <p>Revoke token if you found suspicious requests.</p>
    `,
  },

  generateText: {
    id: 'manageToken.generateText',
    defaultMessage: 'Press the button to <b>generate the access token</b>.',
  },

  generateAction: {
    id: 'manageToken.generateAction',
    defaultMessage: 'Generate token',
  },

  tokenLabel: {
    id: 'manageToken.tokenLabel',
    defaultMessage: 'Access token',
  },

  copyAction: {
    id: 'manageToken.copyAction',
    defaultMessage: 'Copy',
  },

  copied: {
    id: 'manageToken.copied',
    defaultMessage: 'Token copied to clipboard',
  },

  copyFailed: {
    id: 'manageToken.copyFailed',
    defaultMessage: 'Failed to copy the token',
  },

  showAction: {
    id: 'manageToken.showAction',
    defaultMessage: 'Show token',
  },

  hideAction: {
    id: 'manageToken.hideAction',
    defaultMessage: 'Hide token',
  },

  revokeToken: {
    id: 'manageToken.revokeToken',
    defaultMessage: 'Revoke token',
  },

  revokeWarning: {
    id: 'manageToken.revokeWarning',
    defaultMessage: `
      This action cannot be undone. All company integrations using the old token will stop working.
    `,
  },

  revokeCancel: {
    id: 'manageToken.revokeCancel',
    defaultMessage: 'Cancel',
  },

  confirmationHeading: {
    id: 'manageToken.confirmationHeading',
    defaultMessage: 'Are you sure?',
  },

  stats: {
    id: 'manageToken.stats',
    defaultMessage: 'Statistics',
  },

  statsHeading: {
    id: 'manageToken.statsHeading',
    defaultMessage: 'AH API usage statistics for',
  },

  statsResource: {
    id: 'manageToken.statsResource',
    defaultMessage: 'Resource',
  },

  statsCount: {
    id: 'manageToken.statsCount',
    defaultMessage: 'Calls count',
  },

  statsLoading: {
    id: 'manageToken.statsLoading',
    defaultMessage: 'Loading...',
  },

  statsNoData: {
    id: 'manageToken.statsNoData',
    defaultMessage: 'No data for selected period',
  },
};
